module.exports = __webpack_public_path__ + "img/dub-pause.b110bee0.png";